import React, { Component } from "react";
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Grid,
  Card,
  CardContent,
  Button,
} from "@material-ui/core";
import { PostData } from "../../api/service";
import ShowImage from "./ShowImage";

export default class GeneralNotificationShort extends Component {
  state = {
    data: [],
    isLoaded: false,
  };

  loadData = () => {
    const d = {
      dept_code: this.props.dept_code,
      type: this.props.type,
    };

    PostData(`/getnoticesbytype`, d).then((resp) => {
      this.setState({
        data: resp || [],
        isLoaded: true,
      });
    });
  };

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.dept_code !== this.props.dept_code ||
      prevProps.type !== this.props.type
    ) {
      this.loadData();
    }
  }

  b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = Array.from(slice).map((ch) => ch.charCodeAt(0));
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: contentType });
  }

  showFile = (blob) => {
    const blobObj = this.b64toBlob(blob.data, blob.mime);
    const blobUrl = URL.createObjectURL(blobObj);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${blob.type}_${Math.random() * 1000}.${blob.ext}`;
    link.click();
  };

  handleClick = (data) => {
    PostData(`/getfiledata`, data).then((resp) => {
      this.showFile(resp);
    });
  };

  renderSingleNotification = (notice) => {
    const file = Array.isArray(notice.upload_info)
      ? notice.upload_info[0]
      : null;

    const isImage = file?.mime?.startsWith("image/");
    const isPdf = file?.mime === "application/pdf";

    return (
      <>
        <Typography
          variant="h5"
          gutterBottom
          style={{ margin: "1em 0", fontWeight: 700 }}
        >
          {notice.title}
        </Typography>
        <Typography
          variant="body2"
          dangerouslySetInnerHTML={{ __html: notice.description }}
        />
        <div style={{ marginTop: "1rem" }}>
          {file ? (
            isImage ? (
              <img
                src={file.url}
                alt="attachment"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 8,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                }}
              />
            ) : isPdf ? (
              <iframe
                src={file.url}
                width="100%"
                height="500px"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 8,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
                title="PDF Viewer"
              ></iframe>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.handleClick(file)}
              >
                Download Attachment
              </Button>
            )
          ) : (
            <Typography>No attachments available.</Typography>
          )}
        </div>
      </>
    );
  };

  renderTableView = (notices) => {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Title</strong>
            </TableCell>
            <TableCell>
              <strong>Description</strong>
            </TableCell>
            <TableCell align="center">
              <strong>Download</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {notices.map((notice, index) =>
            Array.isArray(notice.upload_info)
              ? notice.upload_info.map((file, fIndex) => (
                  <TableRow key={`${index}-${fIndex}`}>
                    <TableCell>{notice.title}</TableCell>
                    <TableCell>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: notice.description,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => this.handleClick(file)}
                      >
                        Download {fIndex + 1}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              : null
          )}
        </TableBody>
      </Table>
    );
  };

  render() {
    const { data, isLoaded } = this.state;

    if (!isLoaded) {
      return (
        <Container>
          <Typography>Loading . . .</Typography>
        </Container>
      );
    }

    if (data.length === 1 && data[0].upload_info?.length === 1) {
      return (
        <Container style={{ marginTop: "2rem" }}>
          {this.renderSingleNotification(data[0])}
        </Container>
      );
    }

    // Otherwise show table view
    return (
      <Container style={{ marginTop: "2rem" }}>
        <Typography variant="h5" gutterBottom>
          {this.props.title}
        </Typography>
        {this.renderTableView(data)}
      </Container>
    );
  }
}
